import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { numberFormatAsString } from "commons/ultilities";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IEmployeeProperties } from "mobx-stores/_models/employee/employee";
import { useStores } from "mobx-stores/_root-store";
import { getLabelOfBranch } from "pages/stella-inspection-note/share";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DetailIconButton } from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const EmployeeTable = observer(() => {
  const {
    inProgress,
    employeeManagement: { getEmployees, pagination, employees, setProp },
  } = useStores();
  const navigate = useNavigate();

  useEffect(() => {
    getEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    async (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      await getEmployees();
    },
    [getEmployees, pagination]
  );

  const goDetailHandler = useCallback(
    (employee: IEmployeeProperties) => {
      navigate(`${employee.id}`);
      setProp("employeeDetail", cloneDeep(employee));
    },
    [navigate, setProp]
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
        disabled: inProgress,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell align="center">STT</TableCell>
          <TableCell align="center">Mã NV</TableCell>
          <TableCell align="center">Họ & Tên</TableCell>
          <TableCell align="center">H/S Năm</TableCell>
          <TableCell align="center">Bộ Phận/ Khâu SX</TableCell>
          <TableCell align="center">Chức Vụ</TableCell>
          <TableCell align="center">Cấp Bậc</TableCell>
          <TableCell align="center">Trình Độ</TableCell>
          <TableCell align="center">Giới Tính</TableCell>
          <TableCell align="center">Tuổi</TableCell>
          <TableCell align="center">Chi Nhánh</TableCell>
          <TableCell align="center">Ghi chú</TableCell>

          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {employees.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell align="center">
              {x.orderNumber && numberFormatAsString(x.orderNumber?.toString())}
            </TableCell>
            <TableCell align="center">{x.code || ""}</TableCell>
            <TableCell>{x.fullName || ""}</TableCell>
            <TableCell align="center">
              {x.hsYear &&
                numberFormatAsString(x.hsYear.toString(), {
                  decimalScale: 2,
                  emtyWhenZero: false,
                })}
            </TableCell>
            <TableCell>{x.departmentType?.name || ""}</TableCell>
            <TableCell>{x.position || ""}</TableCell>
            <TableCell align="center">{x.level || ""}</TableCell>
            <TableCell align="center">{x.qualification || ""}</TableCell>
            <TableCell align="center">{x.genderModel?.value || ""}</TableCell>
            <TableCell align="center">{x.age || ""}</TableCell>
            <TableCell align="center">
              {x?.branch ? getLabelOfBranch(x?.branch) : ""}
            </TableCell>
            <TableCell>{x.note || ""}</TableCell>
            <TableCell width={"20px"}>
              <DetailIconButton
                onClick={() => goDetailHandler(x)}
              ></DetailIconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
